import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { AuthService } from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router) { }

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        try {
            return this.auth.getSignedIn().pipe(
                map(signedIn => {
                    if (signedIn) {
                        return true;
                    }
                    console.info("Not signed in...");
                    this.auth.setRedirectTo(state.url);
                    this.router.navigate(["/user/login"]);
                    return false;
                })
            );
        } catch (e) {
            console.warn("error in AuthGuard.canActivate", e);
        }
        this.router.navigate(["/error"]);
        return of(false);
    }
}
